import { render, staticRenderFns } from "./ReleasesMyReleasesList.vue?vue&type=template&id=0d0fb11c&"
import script from "./ReleasesMyReleasesList.vue?vue&type=script&lang=js&"
export * from "./ReleasesMyReleasesList.vue?vue&type=script&lang=js&"
import style0 from "./ReleasesMyReleasesList.vue?vue&type=style&index=0&id=0d0fb11c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports